import {isTablet, isIPad13, isIOS, isMacOs, getUA} from 'react-device-detect';

export default function isIpadDevice() {
	let ua = '';
	if (typeof getUA === 'string' && getUA) {
		ua = getUA;
	} else if (typeof navigator !== 'undefined' && navigator.userAgent) {
		ua = navigator.userAgent;
	}

	const hasNavigator = typeof navigator !== 'undefined';
	const maxTouchPoints =
		hasNavigator && typeof navigator.maxTouchPoints === 'number'
			? navigator.maxTouchPoints
			: 0;

	return Boolean(
		(isMacOs && maxTouchPoints > 1) ||
			/iPad/i.test(ua) ||
			isIPad13 ||
			(isIOS && isTablet)
	);
}
